import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import PersonnelDetails from "../../components/Personnel/PersonnelDetails";


const PersonnelShow = ({personnel}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('personnel.details')}
            items={[
                {
                    icon: 'arrow_back_ios',
                    text: i18n.get('default.nav.back'),
                    href: '/personnel',
                    color: 'secondary',
                    size: 'small',
                },
                {
                    icon: 'edit',
                    text: i18n.get('personnel.edit'),
                    href: `/personnel/${personnel.id}/edit`,
                    size: 'small',
                }
            ]}
        />

        <PersonnelDetails personnel={personnel} />

    </Layout>
);

export default PersonnelShow;
